import { compareDesc, parseISO } from 'date-fns';

import { useBrazeContext } from 'contexts/braze';
import { BrazeCard, BrazeContentCardTypes } from 'contexts/braze/types';

import { BannerV1ContentCard } from './BannerV1ContentCard';
import { RivalsContentCard } from './RivalsContentCard';

type ContentCardComponent = {
  card: BrazeCard;
};
export const contentCardsComponent: {
  [key in BrazeContentCardTypes]: ({
    card,
  }: ContentCardComponent) => React.JSX.Element | null;
} = {
  [BrazeContentCardTypes.BANNER_V1]: BannerV1ContentCard,
  [BrazeContentCardTypes.RIVALS]: RivalsContentCard,
};

const highestPriorityCard = (cards: BrazeCard[]): BrazeCard => {
  return cards.sort((a, b) => {
    const aPriority = parseInt(a.extras.priority, 10);
    const bPriority = parseInt(b.extras.priority, 10);

    if (aPriority === bPriority) {
      return compareDesc(parseISO(a.created), parseISO(b.created));
    }
    return bPriority - aPriority;
  })[0];
};

type Props = { type: BrazeContentCardTypes };
export const ContentCard = ({ type }: Props) => {
  const { data } = useBrazeContext();

  const cardToDisplay = highestPriorityCard(
    data.cards.filter(card => type === card.extras.type)
  );

  if (!cardToDisplay) {
    return null;
  }

  const Component = contentCardsComponent[cardToDisplay.extras.type];
  return <Component card={cardToDisplay} />;
};
